const academyReworkings = {
	main: 'Reworkings',
	welcome: 'Welcome, {{name}}!',
	startDescription: 'Choose a location, group and program to book a reworking.',
	studentRequired: 'Reworking booking is available for a selected student.',
	location: 'Location',
	group: 'Group',
	program: 'Program',
	selectLocation: 'Choose a location first.',
	selectGroup: 'Choose a group first.',
	selectProgram: 'Choose a program before booking.',
	noOptions: 'No options available',
	retry: 'Retry',
	book: 'Book a reworking',
	bookDescription: 'Choose up to three lessons, then a time and a tutor.',
	myBookings: 'My bookings',
	myBookingsDescription: 'Your reworking bookings.',
	viewBooking: 'Details',
	bookingDetails: 'Booking details',
	bookingDate: 'Date',
	lesson: 'Lesson',
	zoomId: 'Zoom ID',
	zoomAccessCode: 'Zoom access code',
	zoomLink: 'Zoom link',
	miroLink: 'Miro link',
	teacherComment: 'Teacher comment',
	studentComment: 'Your comment',
	closeDetails: 'Close',
	noBookings: 'You have no upcoming reworkings yet.',
	cancellationHint: 'You can cancel a booking at least {{minutes}} minutes before it starts.',
	cancelBooking: 'Cancel',
	cancelTitle: 'Cancel this booking?',
	cancelDescription:
		'{{lesson}} · {{date}}. After cancellation, the lesson will be available to book again.',
	cancellationUnavailable: 'Cancellation is unavailable',
	cancellationBlocked:
		'Less than {{minutes}} minutes remain before the session starts. Contact your location administrator if you need help.',
	keepBooking: 'Keep booking',
	confirmCancel: 'Yes, cancel',
	understood: 'Understood',
	online: 'Online',
	offline: 'Offline',
	chooseLessons: 'Which lessons would you like to make up?',
	lessonsHint: 'Choose up to 3 missed lessons. Each session lasts 20 minutes.',
	noLessons: 'No missed lessons are available for this program.',
	missedOn: 'Missed on {{date}}',
	selectedLessons: 'Selected: {{count}} of 3',
	nextDays: 'Next: days',
	nextTime: 'Next: time',
	chooseDays: 'Choose suitable days',
	daysHint: 'Select one or more days. You can see how many times are available before continuing.',
	selectDay: 'Select day {{date}}',
	selectedDays: 'Selected days: {{count}}',
	availableTimes: 'Available times: {{count}}',
	noTimes: 'No available times',
	dayNoSlots: 'No times remain for this day. Go back to choose another day.',
	selected: 'Selected',
	days: 'Days',
	time: 'Time',
	chooseTimes: 'Choose your times',
	timesHint: 'Choose {{count}} slots of 20 minutes across your selected days.',
	previousWeek: 'Previous week',
	nextWeek: 'Next week',
	currentWeek: 'Current week',
	timeZone: 'All times are shown in Kyiv time.',
	bookingDeadline: 'Book more than {{hours}} hours before the session starts.',
	tutorsAvailable: 'Available tutors: {{count}}',
	selectTime: 'Select {{date}}, {{time}}',
	noSlots: 'No available 20-minute slots this week. Try another week.',
	selectedTimes: 'Selected times: {{count}} of {{total}}',
	nextTutor: 'Next: tutors',
	chooseTutors: 'Your tutors',
	tutorsHint:
		'The tutor with the lowest workload is selected first. You can choose another available tutor.',
	tutor: 'Tutor',
	selectTutor: 'Choose a tutor.',
	nextConfirm: 'Next: confirmation',
	confirmTitle: 'Confirm your booking',
	partiallyBooked: 'Already booked: {{count}}. A retry will only book the remaining lessons.',
	booked: 'Booked',
	phone: 'Phone number',
	contactHint: 'This phone number and comment will be added to each selected booking.',
	stepProgress: 'Step {{current}} of {{total}}',
	comment: 'Comment (optional)',
	confirmBooking: 'Confirm booking',
	requestFailed: 'Could not load or save your booking. Please try again.',
	slotsChanged:
		'Some times are no longer available or the booking deadline has passed. Choose another time.',
	lessons: 'Lessons',
	dateTime: 'Date and time',
	confirmation: 'Confirmation',
	back: 'Back',
};

export default academyReworkings;
